// TODO: KPI / khoá học thật khi có dữ liệu (A). Số MẪU theo script board Mint-Mee (khối "KPI & học tập"); không có tiền.

export const KPI_PERIOD = '10/2026';

export type Tone = 'ok' | 'warn' | 'err';

export interface Kpi {
  k: string;
  /** hiển thị, vd "92%" */
  v: string;
  goal: string;
  tone: Tone;
  /** độ dài thanh / vạch mục tiêu, 0–100 */
  w: number;
  gl: number;
  aria: string;
}

type KpiRow = readonly [string, number, number, string];

const KPI_SALE: KpiRow[] = [
  ['Job mới', 18, 20, ''],
  ['Báo giá gửi đúng hạn', 92, 95, '%'],
  ['Khách được follow', 34, 40, ''],
  ['Booking Confirmed đúng hạn', 88, 85, '%'],
];
const KPI_OPS: KpiRow[] = [
  ['Job xử lý', 46, 45, ''],
  ['SI đúng cut-off', 97, 98, '%'],
  ['Phản hồi mail ≤ 2 giờ làm việc', 91, 90, '%'],
  ['Draft B/L đúng hạn', 94, 95, '%'],
];

/** Bộ chỉ tiêu theo ghế: phòng Kinh doanh dùng bộ sale, còn lại bộ nghiệp vụ. */
export function kpisOf(dept: string): Kpi[] {
  return (dept === 'Kinh doanh' ? KPI_SALE : KPI_OPS).map(([k, v, g, u]) => {
    const mx = u ? 100 : Math.max(v, g) * 1.15;
    const tone: Tone = v >= g ? 'ok' : v / g >= 0.9 ? 'warn' : 'err';
    return { k, v: `${v}${u}`, goal: `${g}${u}`, tone, w: (v / mx) * 100, gl: (g / mx) * 100, aria: `${k} ${v}${u} trên mục tiêu ${g}${u}` };
  });
}

export interface Course {
  k: string;
  cat: string;
  /** 0–1 */
  p: number;
  pct: string;
  /** số ngày tới hạn (âm = quá hạn), null = tự chọn */
  due: number | null;
  required: boolean;
  tone: 'ok' | 'warn' | 'err' | 'pri' | 'neutral';
  badge: string;
  cta: 'Thi' | 'Học tiếp' | 'Bắt đầu';
  aria: string;
}

const COURSES: ReadonlyArray<readonly [string, string, number, number, number | null, boolean]> = [
  ['Release B/L theo mức nợ', 'SOP · Tài chính', 0, 4, -1, true],
  ['Gửi bill qua hệ thống', 'SOP · Chứng từ & B/L', 3, 6, 2, true],
  ['Báo giá Live', 'Hướng dẫn · Kinh doanh', 5, 5, 6, true],
  ['Kiêm nhiệm & luật duyệt', 'Quy định nội bộ', 2, 3, null, false],
];

export function coursesOf(): Course[] {
  return COURSES.map(([k, cat, done, total, due, required]) => {
    const p = done / total;
    const tone: Course['tone'] = due === null ? 'neutral' : due < 0 ? 'err' : due <= 3 ? 'warn' : 'pri';
    const badge = due === null ? 'Tự chọn' : due < 0 ? `Quá hạn ${-due} ngày` : p === 1 ? 'Chờ thi' : `Còn ${due} ngày`;
    const cta = p === 1 ? 'Thi' : done ? 'Học tiếp' : 'Bắt đầu';
    return { k, cat, p, pct: `${Math.round(p * 100)}%`, due, required, tone, badge, cta, aria: `${p === 1 ? 'Thi' : 'Học'} ${k} trong HANA Edu` };
  });
}

/** khoá bắt buộc quá hạn hoặc còn ≤ 3 ngày */
export const courseDueCount = (cs: Course[]): number => cs.filter((c) => c.required && c.due !== null && c.due <= 3).length;
